(() => {
  if (window.vdContactInstalled) return;
  window.vdContactInstalled = true;
  // Validate email before the existing delegated submission and routing handlers.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) ||
        !form.matches('[data-vd-contact] .vct__form form.contact-form')) return;
    const email = form.querySelector('input[name="contact[email]"]');
    if (!email || email.validity.valid) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    email.reportValidity();
  }, true);
  const pending = new Map();
  let chatSource;
  let chatEventsBound = false;
  const bindChatEvents = () => {
    if (chatEventsBound) return;
    window.zE('messenger:on', 'open', () => chatSource?.setAttribute('aria-expanded', 'true'));
    window.zE('messenger:on', 'close', () => {
      if (chatSource?.isConnected) {
        chatSource.setAttribute('aria-expanded', 'false');
        chatSource.focus();
      }
      chatSource = null;
    });
    chatEventsBound = true;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-vct-chat]');
    if (!button || pending.has(button)) return;
    const root = button.closest('[data-vd-contact]');
    const status = root.querySelector('[data-vct-chat-status]');
    let attempts = 0;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = button.dataset.loadingLabel;
    const finish = failed => {
      clearInterval(pending.get(button));
      pending.delete(button);
      button.removeAttribute('aria-busy');
      if (status) status.textContent = failed ? status.dataset.unavailable : '';
    };
    const open = () => {
      if (!button.isConnected) { finish(false); return; }
      if (typeof window.zE === 'function') {
        try { bindChatEvents(); chatSource = button; window.zE('messenger', 'show'); window.zE('messenger', 'open'); finish(false); }
        catch (_) { finish(true); }
      } else if (++attempts >= 20) finish(true);
    };
    pending.set(button, setInterval(open, 250));
    open();
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-vct-chat]').forEach(button => { clearInterval(pending.get(button)); pending.delete(button); });
  });
})();
